var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusTutorial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1006 6.60044L8.26714 6.61807V0.899404C8.26714 0.401124 7.86601 0 7.36774 0C6.86962 0 6.46833 0.401124 6.46833 0.899404L6.48597 6.6006H0.899404C0.401124 6.6006 0 7.00172 0 7.5C0 7.99812 0.401124 8.39924 0.899404 8.39924H6.47715V14.1006C6.47715 14.5986 6.87827 15 7.37655 15C7.87483 15 8.27596 14.5986 8.27596 14.1006V8.3994H14.1006C14.5989 8.3994 15 7.99796 15 7.5C15 7.00156 14.5944 6.60044 14.1006 6.60044Z",
    fill: "#05275D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusTutorial);
export default __webpack_public_path__ + "static/media/plus-tutorial.62ecf68d192fb896fb714309f0e276d5.svg";
export { ForwardRef as ReactComponent };